import React from 'react';
import { Divider } from '../Divider';
import styles from './SectionWrapper.module.scss';

interface SectionWrapperProps {
  children: React.ReactNode;
  name?: string;
  noDivider?: boolean;
}

export const SectionWrapper: React.FC<SectionWrapperProps> = ({ children, name, noDivider = false }) => {
  if (children == null || (Array.isArray(children) && children.length === 0)) {
    return null;
  }

  return (
    <>
      <div className={styles.section} data-testid={`section-wrapper-${name}`}>
        {children}
      </div>
      {!noDivider && <Divider />}
    </>
  );
};
